import * as React from 'react';
import type { IconProps } from '../Icon';
import { Icon } from '../Icon';

/**
 * Element that is used when action Icon is wrapped inside <button>.
 * Attributes of Icon are set in a way in which it conforms to WCAG.
 * @param iconName
 * @param fontBoostWidthMultiplier
 * @param fontBoostHeightMultiplier
 */
export function ButtonIcon({
  iconName,
  fontBoostWidthMultiplier,
  fontBoostHeightMultiplier
}: Omit<IconProps, 'role' | 'aria-label'>): React.JSX.Element {
  return (
    <Icon
      iconName={iconName}
      aria-label={undefined}
      fontBoostWidthMultiplier={fontBoostWidthMultiplier}
      fontBoostHeightMultiplier={fontBoostHeightMultiplier}
    />
  );
}
